import axios from 'axios'
import {CLOUD_API} from "@/store/action-path";

export function updatePassword(data) {
  let url = `${CLOUD_API}/staff/home/update/pwd`
  return axios.post(url, data)
}
